import * as React from 'react';
import styled from 'styled-components';
import { animated, useSpring } from '@react-spring/web';
import { useModal } from '../../../hooks/useModal';

export const ModalOverlay: React.FC = React.memo(() => {
  const { show, initialAnimation, delay, overlayOpacity } = useModal();
  const animatedProps = useSpring({
    immediate: !initialAnimation,
    delay: delay ? delay : 0,
    from: { opacity: 0, transform: 'translate3d(0, -1em, 0)' },
    to: {
      opacity: show ? 1 : 0,
      transform: show ? 'translate3d(0, 0em, 0)' : 'translate3d(0, -1em, 0)'
    }
  });
  return <StyledModalOverlay style={animatedProps} $overlayOpacity={overlayOpacity} />;
});

const StyledModalOverlay = styled(animated.div)<{ $overlayOpacity?: number }>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${({ $overlayOpacity }) =>
    $overlayOpacity
      ? `var(--modal-overlay-background, rgba(0, 0, 0, ${$overlayOpacity}))`
      : 'var(--modal-overlay-background,rgba(0, 0, 0, 0.85))'};
  z-index: 9998;
`;
